
import {
  DropdownMenu,
  DropdownMenuContent,
  // DropdownMenuGroup,
  // DropdownMenuItem,
  DropdownMenuLabel,
  // DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
// import { useGetProfile } from '@/lib/hooks/api/profile.hook';
import { useUserStore } from '@/store';
// import { Logout } from '../shared/Logout';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';

export function ProfileDropdown() {
  const { user } = useUserStore();
  // const { data } = useGetProfile();

  // const profile = data?.data?.data ?? user;
  const profile = user;

  return (
    <>
      <div className='hidden md:flex items-center gap-3'>
        <div className='hidden md:flex flex-col items-end'>
          <p>{profile?.name as string}</p>
          <p className="text-muted-foreground text-xs">
            {profile?.email as string}
          </p>
        </div>
        <Avatar>
          <AvatarImage
            src={profile?.userImage as string}
            alt="profile"
            className="w-full h-full object-cover"
          />
          <AvatarFallback className="text-2xl uppercase bg-primary text-primary-foreground border">
            {profile?.name?.[0] as string}
          </AvatarFallback>
        </Avatar>
      </div>

      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild className='md:hidden'>
          <div
            role="button"
            className="flex items-center h-full rounded-none gap-3 hover:bg-secondary transition hover:text-secondary-foreground px-1 md:px-2 -mr-1 md:-mr-2"
            data-testid="profile-dropdown-trigger"
          >
            {/* {profile?.firstName && (
              <h5 className="capitalize hidden md:block ">
                {profile?.firstName as string}
              </h5>
            )} */}

            <Avatar>
              <AvatarImage
                src={profile?.userImage as string}
                alt="profile"
                className="w-full h-full object-cover"
              />
              <AvatarFallback className="text-2xl uppercase bg-primary text-primary-foreground border">
                {profile?.name?.[0] as string}
              </AvatarFallback>
            </Avatar>
          </div>
        </DropdownMenuTrigger>

        <DropdownMenuContent className="min-w-[200px]" align="end">
          <DropdownMenuLabel>
            <p>{profile?.name as string}</p>
            <p className="text-muted-foreground text-xs">
              {profile?.email as string}
            </p>
          </DropdownMenuLabel>
          {/* <DropdownMenuSeparator />
        <DropdownMenuItem
          className="w-full cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
          }}
          data-testid="logout-profile-dropdown"
        >
          <Logout>
            <span className="w-full">Log out</span>
          </Logout>
        </DropdownMenuItem> */}
        </DropdownMenuContent>
      </DropdownMenu>
    </>

  );
}
